import { useContextFallback } from '@prenuvo/halo';

import { PatientDocsContext } from './patient-docs.context';

export const usePatientDocs = () => useContextFallback(PatientDocsContext);
